/** Lazy Load View **/
function loadView(view) {
	return () => import(/* webpackChunkName: "view-[request]" */ `@/modules/dashboard/_components/${view}.vue`)
}

let routes = [
	{
		path: '',
		name: 'home',
		component: loadView('index'),
		meta: {
			auth: true
		}
	},{
		path: '/child-info/:id',
		name: 'child-info',
		component: loadView('childinfo'),
		meta: {
			auth: true
		}
	}
];

export default routes;